/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Hero_H1_EmInputs */

const es_gift_hero_h1_em = /** @type {(inputs: Gift_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mar.`)
};

const gl_gift_hero_h1_em = /** @type {(inputs: Gift_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mar.`)
};

const en_gift_hero_h1_em = /** @type {(inputs: Gift_Hero_H1_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sea.`)
};

/**
* | output |
* | --- |
* | "sea." |
*
* @param {Gift_Hero_H1_EmInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_hero_h1_em = /** @type {((inputs?: Gift_Hero_H1_EmInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Hero_H1_EmInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_hero_h1_em(inputs)
	if (locale === "en") return en_gift_hero_h1_em(inputs)
	return es_gift_hero_h1_em(inputs)
});